import { render } from "./StarOptions.vue?vue&type=template&id=6e190fa0"
import script from "./StarOptions.vue?vue&type=script&lang=js"
export * from "./StarOptions.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__